import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, errMsg } from "@/lib/api";

export default function TripAssignee({ trip, isAdmin, onSaved, autoOpen = false }) {
  const api = useApi();
  const [team, setTeam] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    if (isAdmin) api.get("/flight-team").then((r) => setTeam(r.data)).catch(() => {});
  }, [api, isAdmin, trip.assigned_to_id]);

  useEffect(() => {
    if (autoOpen && isAdmin && team.length) {
      box.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(() => setOpen(true), 400);
    }
  }, [autoOpen, isAdmin, team.length]);

  const assign = async (v) => {
    try {
      const { data } = await api.post(`/trips/${trip.id}/assign`, { user_id: v === "none" ? null : v });
      toast.success(data.assigned_to_name ? `Assigned to ${data.assigned_to_name}. They've been notified.` : "Assignment removed");
      onSaved(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="col-span-2" ref={box} data-testid="trip-assignee">
      <p className="text-[0.58rem] tracking-[0.22em] uppercase text-zinc-500">Assigned to</p>
      {isAdmin ? (
        <Select value={trip.assigned_to_id || "none"} onValueChange={assign} open={open} onOpenChange={setOpen}>
          <SelectTrigger className="mt-1.5 h-10 bg-[#0d0f14] border-white/10 text-sm" data-testid="trip-assign-select"><SelectValue placeholder={trip.assigned_to_name || "Unassigned"} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none" data-testid="trip-assign-none">Unassigned</SelectItem>
            {!team.length && trip.assigned_to_id && <SelectItem value={trip.assigned_to_id}>{trip.assigned_to_name}</SelectItem>}
            {team.map((u) => <SelectItem key={u.id} value={u.id} data-testid={`trip-assign-${u.id}`}>{u.name || u.email} · {u.open_trips} open trip{u.open_trips === 1 ? "" : "s"}</SelectItem>)}
          </SelectContent>
        </Select>
      ) : (
        <p className="text-sm text-zinc-100 mt-1" data-testid="trip-assignee-name">{trip.assigned_to_name || "Unassigned"}</p>
      )}
    </div>
  );
}
